import type { CSSProperties } from 'react'
import { C } from '../theme'

const NAV = [
  { id: 'nosotros', label: 'Nosotros' },
  { id: 'eventos', label: 'Eventos' },
  { id: 'calendario', label: 'Calendario' },
  { id: 'ayuda', label: 'Ayuda' },
  { id: 'redes', label: 'Redes' },
  { id: 'contacto', label: 'Contacto' },
]

interface HeaderProps {
  progress: number
  scrolled: boolean
  active: string
}

export function Header({ progress, scrolled, active }: HeaderProps) {
  return (
    <>
      <div
        aria-hidden
        style={{
          position: 'fixed', top: 0, left: 0, height: 3, width: `${progress}%`,
          background: `linear-gradient(90deg,${C.red},${C.blue})`, zIndex: 70,
          transition: 'width .1s linear',
        }}
      />
      <header
        style={{
          position: 'sticky', top: 0, zIndex: 50,
          background: 'rgba(250,246,239,.9)', backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(193,39,45,.14)',
          boxShadow: scrolled ? '0 6px 22px rgba(21,35,63,.10)' : 'none',
          transition: 'box-shadow .3s ease',
        }}
      >
        <div
          className="header-inner"
          style={{
            maxWidth: 1220, margin: '0 auto', display: 'flex', alignItems: 'center',
            justifyContent: 'space-between', padding: scrolled ? '6px 40px' : '12px 40px',
            transition: 'padding .3s ease',
          }}
        >
          <a href="#top" style={{ display: 'flex', alignItems: 'center', gap: 13, textDecoration: 'none' }}>
            <img src="/assets/casita-emblem.png" alt="Casita de Dios" style={{ height: 46, width: 'auto', display: 'block' }} />
            <div style={{ lineHeight: 1 }}>
              <div style={{ fontFamily: "'Spectral',serif", fontSize: 20, fontWeight: 600, color: C.blue, letterSpacing: '.01em' }}>
                La Casita de Dios
              </div>
              <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: C.red, marginTop: 3 }}>
                Amor · Fe · Esperanza
              </div>
            </div>
          </a>
          <nav
            className="nav"
            style={{
              display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center',
              gap: 22, fontSize: 14.5, fontWeight: 600, color: '#3f3a33',
            }}
          >
            {NAV.map((n) => (
              <a
                key={n.id}
                className="navlink"
                href={`#${n.id}`}
                style={{ textDecoration: 'none', color: active === n.id ? C.red : undefined } as CSSProperties}
              >
                {n.label}
              </a>
            ))}
            <a
              className="btn"
              href="#donar"
              style={{ textDecoration: 'none', background: C.red, color: '#fff', padding: '10px 20px', borderRadius: 3, fontWeight: 700 }}
            >
              Donar
            </a>
          </nav>
        </div>
      </header>
    </>
  )
}
